import React, { useEffect, useState } from "react";
import PagesHeader from "@components/PagesHeader";
import "./style.scss";
import { Outlet, useLocation, useNavigate } from "react-router";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "@api/consumer";
import { useQueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import Loader from "@components/Loader";
import {
  getBadgeStats,
  ACTIVATION_STALE_TIME,
  ACTIVATION_CACHE_TIME,
} from "@api/activation";

export default function UltraInsider() {
  const navigate = useNavigate();
  const location = useLocation();
  const [content, setContent] = useState();
  const queryClient = useQueryClient();

  const { isLoading: badgeStatsLoading } = useQuery({
    queryKey: ["badge-stats-ultra-insider-stats"],
    queryFn: () =>
      getBadgeStats({
        successCallback: () => {
          setTimeout(() => {
            queryClient.invalidateQueries({ queryKey: ["user-details"] });
          }, 100);
        },
      }),
    refetchOnMount: "always",
    suspense: false,
    cacheTime: ACTIVATION_CACHE_TIME,
    staleTime: ACTIVATION_STALE_TIME,
  });

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: () => (badgeStatsLoading ? () => {} : getUserDetails()),
    enabled: !!localStorage.getItem("token"),
    suspense: false,
    // refetchOnMount: "always",
    cacheTime: DETAILS_CACHE_TIME,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
  });

  const ultraInsider = data?.consumer?.ultraInsider ?? false;

  const redirectTo = () => {
    if (location.pathname === "/ultra-insider") {
      navigate(`/ultra-insider/benefits`);
    }
  };

  useEffect(() => {
    redirectTo();
    setContent(location.pathname);
  }, [location.pathname, data, badgeStatsLoading]);

  if (!data || badgeStatsLoading) {
    return (
      <div className="ultra-insider-page-loader">
        <Loader show={true} className="inside" blackBg={true} />
      </div>
    );
  }
  return (
    <section
      className={`ultra-insider-page ${ultraInsider ? "" : "no-status"}`}
    >
      <PagesHeader>
        <strong> Ultra </strong>Space
      </PagesHeader>
      <div className="tab-navigation">
        <div
          className={`tab-navigation-left ${
            content === "/ultra-insider/benefits" ? "active" : ""
          }`}
          onClick={() => navigate("/ultra-insider/benefits")}
        >
          <p>Vorteile</p>
        </div>
        <div
          className={`tab-navigation-right ${
            content === "/ultra-insider/ultra-care" ? "active" : ""
          }`}
          onClick={() => navigate("/ultra-insider/ultra-care")}
        >
          <p>Ultra Care</p>
        </div>
      </div>
      <div className="insider-page-content">
        <Outlet context={ultraInsider} />
      </div>
    </section>
  );
}
